import { FinancialAccountType } from "@common/types/financialAccount";
import { ViewType } from "@common/types/views/views";
import { documentRetrievalCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

export interface CreateDocumentRetrievalViewConfigParams {
    financialAccountType?: FinancialAccountType | null;
    financialAccountIds?: number[];
    startDateOverride?: string | null;
    endDateOverride?: string | null;
}

function documentRetrievalTargeting({
    financialAccountType = null,
    financialAccountIds = [],
}: CreateDocumentRetrievalViewConfigParams) {
    if (financialAccountIds.length > 0) {
        return { financialAccountIds };
    }
    if (financialAccountType != null) {
        return { financialAccountType };
    }
    return {};
}

export function createDocumentRetrievalViewConfig({
    financialAccountType = null,
    financialAccountIds = [],
    startDateOverride = null,
    endDateOverride = null,
}: CreateDocumentRetrievalViewConfigParams = {}) {
    return documentRetrievalCloseTemplateViewConfigSchema.parse({
        type: ViewType.FINANCIAL_DOCUMENT,
        columns: [],
        filters: {},
        ...documentRetrievalTargeting({
            financialAccountType,
            financialAccountIds,
        }),
        ...(startDateOverride != null ? { startDateOverride } : {}),
        ...(endDateOverride != null ? { endDateOverride } : {}),
    });
}
